module.exports = __webpack_public_path__ + "static/vello-logo-9931a8f0521c0044ef97e1b79aa072d6.png";